import { Languages } from "src/common/descriptions/types";
import { CreateServiceDescriptions } from "./types";

const DescriptionsEnUs: CreateServiceDescriptions = {
    EDIT_TITLE: "Edit Service",
    TITLE: "Create Service",
    SAVE_BUTTON: "Save",
    CANCEL_BUTTON: "Cancel",
    CONFIRM_MODAL: {
        TITLE: 'Save service?',
        DESCRIPTION: "Operation will not be reverted.",
        ACTION_BUTTON: "Save",
        CANCEL_BUTTON: "Go Back",
    },
    CANCEL_MODAL: {
        TITLE: "Cancel service input?",
        DESCRIPTION: "All data will be lost.",
        ACTION_BUTTON: "Yes, Cancel",
        CANCEL_BUTTON: "Keep working",
    },
    SUCCESS_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Service Created",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Service Updated",
    },
    FORM: {
        NAME: {
            LABEL: "Name",
            PLACEHOLDER: "Input pervice name",
        },
        PRICE: {
            LABEL: "Price",
            PLACEHOLDER: "Input price",
        },
        IS_MONTHLY: {
            LABEL: "Monthly Service",
            PLACEHOLDER: "Select",
        },
        CHARACTERISTICS: {
            LABEL: "Characteristics",
            PLACEHOLDER: "Add characteristics",
        },
        IS_ACTIVE: {
            LABEL: "Status",
            PLACEHOLDER: "Select status",
        },
        CATEGORY: {
            LABEL: "Category",
            PLACEHOLDER: "Select category",
        },
        IMAGE: {
            LABEL: "Service Image",
            PLACEHOLDER: "Upload",
        },
        EXTERNAL_ID: {
            LABEL: "External ID",
            PLACEHOLDER: "Input external Id",
        },
    },
    MAIN_ACTION_TITLE: "Creating Service",
    MAIN_ACTION_DESCRIPTION: "Please wait...",
    ADD: "Add",
    REMOVE: "Remove",
}

const DescriptionsEsUs: CreateServiceDescriptions = {
    EDIT_TITLE: "Editar Servicio",
    TITLE: "Crear Servicio",
    SAVE_BUTTON: "Guardar",
    CANCEL_BUTTON: "Cancelar",
    CONFIRM_MODAL: {
        TITLE: 'Guardar Servicio con los datos ingresados?',
        DESCRIPTION: "La operación no podrá ser revertida.",
        ACTION_BUTTON: "Guardar",
        CANCEL_BUTTON: "Regresar",
    },
    CANCEL_MODAL: {
        TITLE: "Cancelar ingreso de Servicio?",
        DESCRIPTION: "La información ingresada sera borrada.",
        ACTION_BUTTON: "Si, Cancelar",
        CANCEL_BUTTON: "Seguir ingresando",
    },
    SUCCESS_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Servicio creado",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Servicio Actualizado",
    },
    FORM: {
        NAME: {
            LABEL: "Nombre",
            PLACEHOLDER: "Ingrese nombre",
        },
        PRICE: {
            LABEL: "Precio",
            PLACEHOLDER: "Ingrse precio",
        },
        IS_MONTHLY: {
            LABEL: "Servicio Mensual",
            PLACEHOLDER: "Seleccione",
        },
        CHARACTERISTICS: {
            LABEL: "Catecterísticas",
            PLACEHOLDER: "Agregar caracteristicas",
        },
        IS_ACTIVE: {
            LABEL: "Estado",
            PLACEHOLDER: "Seleccione estado",
        },
        CATEGORY: {
            LABEL: "Categoría",
            PLACEHOLDER: "Seleccione categoría",
        },
        IMAGE: {
            LABEL: "Imágen de Servicio",
            PLACEHOLDER: "Cargar",
        },
        EXTERNAL_ID: {
            LABEL: "Código externo",
            PLACEHOLDER: "Ingresa código externo",
        },
    },
    MAIN_ACTION_TITLE: "Creando Categoría",
    MAIN_ACTION_DESCRIPTION: "Por favor espere...",
    ADD: "Agregar",
    REMOVE: "Quitar",
}

export const createServiceDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}